import { BookOpenPageVariantIcon } from './BookOpenPageVariantIcon';

/**
 * author: Google
 * id 113421A1-241F-4479-B22B-5F56EFD63D4C
 * name book-open-page-variant
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/book-open-page-variant.svg
 * tags
 */
export const AutoStoriesIcon = BookOpenPageVariantIcon;
export default AutoStoriesIcon